import Icon from 'components/Icon/Icon';
import { SubscribeBtn } from './SubscribeButton.styled';

const SubscribeButton = () => {
  return (
    <SubscribeBtn href="https://t.me/+rU4Xn2iRY5A2Y2Ji">
      Subscribe
      <Icon width="20" height="16" iconName="#icon-arrow" />
    </SubscribeBtn>
  );
};

export default SubscribeButton;
